
import { useState, useRef, useEffect } from 'react';

// Generic imports
import _ from 'lodash';

// Mui imports
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableCell from '@mui/material/TableCell';

// Local imports
import LegEditor from '../../LegEditor.js'

function OpportunityCargowiseCodesModal(props) {
    const { offer, onDone, onCancel, isDoneSave } = props;
    const [ local, setLocal ] = useState(null);

    useEffect(() => {
        if (offer) {
            setLocal(_.cloneDeep(offer));
        } else {
            setLocal(null);
        }
    }, [offer]);

    function onOk() {
        onDone(local);
    }

    if (!offer || !local) return null;

    return (
        <Dialog open={Boolean(offer)} onClose={onCancel} maxWidth={'xl'}>
            <DialogTitle>
                Set up Cargowise Codes
            </DialogTitle>
            <DialogContent>
                <Box sx={{ margin: '12px 0px' }}>
                    If you are planning on exporting your opportunity to Cargowise, you can configure the different codes for your fields here.
                </Box>
                <CargowiseCodeTable offer={local} setOffer={setLocal} />
            </DialogContent>
            <DialogActions sx={{ paddingBottom: '24px', paddingRight: '40px' }}>
                <Button size='small' color='secondary' onClick={onCancel}>
                    Cancel
                </Button>
                <Button
                    size='small' 
                    color='primary' 
                    variant='contained' 
                    onClick={() => {
                        onOk()
                    }}
                >
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    );
}

// Down arrow or Enter moves to the next field's code, up arrow to the previous one.
function moveBetweenCodes(e) {
    const step = e.key === 'ArrowDown' || e.key === 'Enter' ? 1 : e.key === 'ArrowUp' ? -1 : 0;
    if (!step) return;
    const inputs = Array.from(e.target.closest('table').querySelectorAll('input[data-cw-code]'));
    const next = inputs[inputs.indexOf(e.target) + step];
    if (!next) return;
    e.preventDefault();
    next.focus();
    next.select();
}

function CargowiseCodeTable(props) {
    const { offer, setOffer } = props;

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell>
                        Section
                    </TableCell>
                    <TableCell>
                        Field
                    </TableCell>
                    <TableCell>
                        Code
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {_.flatten(offer.sections.map((section, sectionIndex) => _.flatten(section.offers.map((sectionOffer, sectionOfferIndex) =>
                    sectionOffer.fields.map((field, fieldIndex) => (
                        <TableRow key={`${sectionIndex}-${sectionOfferIndex}-${fieldIndex}`}>
                            <TableCell>
                                {section.title || `Section ${sectionIndex + 1}`}
                                {section.offers.length > 1 ? sectionOffer.title || ` (Offer ${sectionOfferIndex + 1})` : ''}
                            </TableCell>
                            <TableCell>
                                {field.title}
                            </TableCell>
                            <TableCell>
                                <TextField
                                    fullWidth
                                    inputProps={{ 'data-cw-code': true }}
                                    onKeyDown={moveBetweenCodes}
                                    value={_.get(offer, `sections[${sectionIndex}].offers[${sectionOfferIndex}].fields[${fieldIndex}].cargowiseChargeCode`, '')}
                                    onChange={e => {
                                        const l = _.cloneDeep(offer);
                                        _.set(l, `sections[${sectionIndex}].offers[${sectionOfferIndex}].fields[${fieldIndex}].cargowiseChargeCode`, e.target.value);
                                        setOffer(l);
                                    }}
                                />
                            </TableCell>
                        </TableRow>
                    ))
                ))))}
            </TableBody>
        </Table>
    )
}

export default OpportunityCargowiseCodesModal;
export { CargowiseCodeTable };
